import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a8885e6755b8c0014002f00_1788470516400_0ff9b768/java_apartments/src/app/forgot-password/page.tsx");
